export const AnnieEvents = {};

AnnieEvents.hasActiveEvent = () => {
  return AnnieEvents.isSecondEvent() ||
    AnnieEvents.isAfterHours1() ||
    AnnieEvents.isAfterHours2();
}

AnnieEvents.displayHint = () => {
  return AnnieEvents.isSecondEvent() ||
    AnnieEvents.isAfterHours1() ||
    AnnieEvents.isAfterHours2();
}

AnnieEvents.isSecondEvent = () => {
  // czy był dziś event
  if(EventStateService.annieDailyEventChecked) {
    return false;
  }

  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  // Czy odbył się pierwszy event z Bartem
  if(!EventStateService.bartFirstEvent) {
    return false;
  }

  // Czy MC pracował już 3 razy
  if(Yosemite.EventStateManager.state.it.timesWorkedIT < 3) {
    return false;
  }

  return !EventStateService.annieSecondEvent;
}

AnnieEvents.isAfterHours1 = () => {
  // czy był dziś event
  if(EventStateService.annieDailyEventChecked) {
    return false;
  }

  // Czy odbył się drugi Event
  if(!EventStateService.annieSecondEvent) {
    return false;
  }

  // Czy jest wieczór
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.AFTERNOON) {
    return false;
  }

  return !EventStateService.annieAfterHours1;
}

AnnieEvents.isAfterHours2 = () => {
  // czy był dziś event
  if(EventStateService.annieDailyEventChecked) {
    return false;
  }

  // Czy odbył się AfterHours1
  if(!EventStateService.annieAfterHours1) {
    return false;
  }

  // Czy jest popołudnie
  if(YsControllers.TimeController.getCurrentDayTime() !== YsControllers.TimeController.DayTimeEnum.AFTERNOON) {
    return false;
  }

  return !EventStateService.annieAfterHours2;
}
